const ru = {
  translation: {
    language: 'Русский',
    reset: 'Сбросить',
    click_one: '{{count}} клик',
    click_few: '{{count}} клика',
    click_many: '{{count}} кликов',
  },
};

export default ru;
